import React from 'react';
import PropTypes from 'prop-types';
import { AddonBox, StepDataContainer } from '../../style';
import StepHeader from '../../StepHeader';
import AddStepDataButtons from '../AddStepDataButtons';
import { PRODUCT_ADDONS } from '../../../../helpers/constants';
import ProductAddonItem from '../ProductAddonItem';
import { getOnlyCheckedProducts } from '../../../../helpers/products';
import VariationAddonItem from '../VariationAddonItem';

const AddonStep = ({ step, order, error, goToSlide, currentIndex, lastIndex }) => {
  return (
    <AddonBox
      id={`box-step-${order}`}
      size={4}
      noPadding
      error={error}
      customStyles={{
        display: 'flex',
        alignItems: 'center',
        justifyContent:
          step.addonType === PRODUCT_ADDONS.SELECTED_GLOBAL_VARIATIONS
            ? 'flex-start'
            : 'space-between',
        flexDirection: 'column',
        cursor: 'default',
      }}
    >
      <StepHeader
        step={step}
        order={order}
        currentIndex={currentIndex}
        lastIndex={lastIndex}
        goToSlide={goToSlide}
      />
      <StepDataContainer
        isVariationSelection={
          step.addonType === PRODUCT_ADDONS.SELECTED_GLOBAL_VARIATIONS && step.data
        }
      >
        {step.data &&
          step.addonType === PRODUCT_ADDONS.SELECTED_PRODUCTS &&
          getOnlyCheckedProducts(step.data).map((prod, index) => (
            <ProductAddonItem
              key={`product-addon-${prod.id}`}
              product={prod}
              step={step}
              single={getOnlyCheckedProducts(step.data).length === 1}
              isLastProduct={getOnlyCheckedProducts(step.data).length - 1 === index}
            />
          ))}
        {step.data && step.addonType === PRODUCT_ADDONS.SELECTED_GLOBAL_VARIATIONS && (
          <VariationAddonItem step={step} variation={step.data} />
        )}
      </StepDataContainer>
      <AddStepDataButtons step={step} />
    </AddonBox>
  );
};

AddonStep.propTypes = {
  step: PropTypes.object.isRequired,
  error: PropTypes.bool,
};

export default AddonStep;



// WEBPACK FOOTER //
// ./src/components/ProductAddons/CustomSteps/AddonStep/index.js